import React, { useState } from 'react';
import './PublishSelection.css';
import facebookSVG from './Iconos/facebook.svg';
import IGLogoSVG from './Imagenes/instagram.png';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

interface PublishSelectionProps {
    onInstagramLogin: () => void;
}

const PublishSelection: React.FC<PublishSelectionProps> = ({ onInstagramLogin }) => {
    const { t } = useTranslation();
    const [isInstagramSelected, setIsInstagramSelected] = useState(false); // Estado para saber si Instagram ha sido seleccionado

    const handleInstagramLogin = async () => {
        try {
            const token = localStorage.getItem('token'); // Obtener el token JWT del localStorage
            const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

            console.log(backendUrl);

            const response = await axios.post(`${backendUrl}/login-instagram`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}` // Incluir el token JWT en las cabeceras
                }
            });
            if (response.status === 200) {
                alert('Iniciado sesión en Instagram con éxito');
                onInstagramLogin(); // Llamar a la función pasada como prop
                setIsInstagramSelected(true); // Cambiar el estado a seleccionado
            }
        } catch (error) {
            console.error('Error logging in to Instagram:', error);
            alert('Error al iniciar sesión en Instagram');
        }
    };

    return (
        <div className="publish-selection-container">
            <span>{t('Publicacion')}.</span>
            <div className="icons-container">
                <button
                    onClick={handleInstagramLogin}
                    className={isInstagramSelected ? 'selected' : ''}
                >
                    <img src={IGLogoSVG} alt="Instagram" />
                </button>
                <button>
                    <img src={facebookSVG} alt="Facebook" />
                </button>
            </div>
        </div>
    );
};

export default PublishSelection;
